import moment from 'moment';

import cloneDeep from 'lodash/cloneDeep';

class FollowUp {
  constructor({
    id, analysisID, poolID, followUpDate, followedUp, deleted, created, modified, imported, blackAlgae, greenAlgae, mustardAlgae, spaAlgae, swampy, slimeMold,
    unknownStaining, organicStaining, ironStaining, copperStaining, waterlineBuildup, scaleBuildup, cloudy, hazy, foaming, chlorineDemand,
  }) {
    this.id = id;
    this.analysisID = analysisID;
    this.poolID = poolID;
    this.followedUp = followedUp;
    this.followUpDate = followUpDate;
    this.deleted = deleted;
    this.created = created;
    this.modified = modified;
    this.imported = imported;

    this.blackAlgae = blackAlgae;
    this.greeAlgae = greenAlgae;
    this.mustardAlgae = mustardAlgae;
    this.spaAlgae = spaAlgae;
    this.swampy = swampy;
    this.slimeMold = slimeMold;
    this.unknownStaining = unknownStaining;
    this.organicStaining = organicStaining;
    this.ironStaining = ironStaining;
    this.copperStaining = copperStaining;
    this.waterlineBuildup = waterlineBuildup;
    this.scaleBuildup = scaleBuildup;
    this.cloudy = cloudy;
    this.hazy = hazy;
    this.foaming = foaming;
    this.chlorineDemand = chlorineDemand;
  }

  clone() {
    return cloneDeep(this);
  }

  toApiModel() {
    return {
      ID: this.id,
      AnalysisID: this.analysisID,
      PoolID: this.poolID,
      FollowedUp: this.followedUp,
      FollowUpDate: moment(this.followUpDate),
      Deleted: this.deleted,
      Created: moment(this.created),
      Modified: moment(this.modified),
      Imported: moment(this.imported),

      BlackAlgae: this.blackAlgae,
      GreenAlgae: this.greenAlgae,
      Swampy: this.swampy,
      SlimeMold: this.slimeMold,
      SpaAlgae: this.spaAlgae,
      MustardAlgae: this.mustardAlgae,

      IronStaining: this.ironStaining,
      CopperStaining: this.copperStaining,
      UnknownStaining: this.unknownStaining,
      OrganicStaining: this.organicStaining,
      WaterlineBuildup: this.waterlineBuildup,
      ScaleBuildup: this.scaleBuildup,

      Cloudy: this.cloudy,
      Hazy: this.hazy,
      Foaming: this.foaming,

      ChlorineDemand: this.chlorineDemand,
    };
  }

  static fromApiFormat(api) {
    return new FollowUp({
      id: api.ID,
      analysisID: api.AnalysisID,
      poolID: api.PoolID,
      followedUp: api.FollowedUp,
      followUpDate: api.FollowUpDate,
      deleted: api.Deleted,
      created: api.Created,
      modified: api.Modified,
      imported: api.Imported,

      blackAlgae: api.BlackAlgae,
      greenAlgae: api.GreenAlgae,
      mustardAlgae: api.MustardAlgae,
      spaAlgae: api.SpaAlgae,
      slimeMold: api.SlimeMold,
      swampy: api.Swampy,

      ironStaining: api.IronStaining,
      copperStaining: api.CopperStaining,
      unknownStaining: api.UnknownStaining,
      organicStaining: api.OrganicStaining,
      waterlineBuildup: api.WaterlineBuildup,
      scaleBuildup: api.ScaleBuildup,

      cloudy: api.Cloudy,
      hazy: api.Hazy,
      foaming: api.Foaming,

      chlorineDemand: api.ChlorineDemand,
    });
  }
}

export default FollowUp;
